import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "universal-cookie";
import { REDIRECT_URL, SERVICE_KEY, TOKEN_NAME } from "./config";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const cookies = new Cookies();
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

if (checkAuth()) {
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  );
}

reportWebVitals();

function checkAuth() {
  const token = cookies.get(TOKEN_NAME);

  if (!token) {
    window.location.href = `${REDIRECT_URL}?pid=${SERVICE_KEY}`;
    return false;
  } else {
    return true;
  }
}
